/**
 * On startup, if URL has legacy query-string params (e.g. /?sectionName=CAD&tab=InProgress),
 * convert to a clean pathname via history.replaceState. Called once in bootstrap before mounting router.
 */

import { legacyUrlToHashPath } from './route-config';

export function redirectLegacyUrl(): void {
  const search = window.location.search;
  if (!search) return;

  // Check if there's a sectionName param or signout param
  const params = new URLSearchParams(search);
  const hasSectionName = params.has('sectionName');
  const hasSignout = params.has('signout') || search === '?signout';

  if (!hasSectionName && !hasSignout) return;

  const cleanPath = legacyUrlToHashPath(search);
  if (!cleanPath) return;

  // Replace the current URL with the clean pathname equivalent
  // e.g. /?sectionName=CAD&tab=InProgress → /cad/in-progress
  history.replaceState(null, '', cleanPath);
}
